import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-arrow-down",
  "use": "svg-arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-arrow-down\">\n  <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n  <polygon points=\"7 9 12 15 17 9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol